





























































































import Vue from 'vue';
import Component from 'vue-class-component';
import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import { Watch } from 'vue-property-decorator';
import { resetModalScroll } from '@/helpers/resetModalScroll';
import { ResultPagDTO, PaginationSyncDTO, IdNomeDTO } from '../../../interfaces/base-dto';
import { FiltroProdutoEnteralParmDTO, ProdutoEnteralListItemDTO } from '@/interfaces/enteral';
import EnteralProductForm from '@/components/enteral/enteral-product-form.vue';
import * as service from '@/services/enteral-product';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiToggleStatus,
    EnteralProductForm,
  },
})
export default class EnteralProduct extends BaseComponent {
  private formIsEdit: boolean = false;
  private formOpen: boolean = false;
  private error: boolean = false;
  private loading: boolean = false;
  private loadingGroups: boolean = false;
  private loadingMakers: boolean = false;
  private grupos: IdNomeDTO[] = [];
  private fabricantes: string[] = [];

  private id: Number = null;
  private filtros: FiltroProdutoEnteralParmDTO = new FiltroProdutoEnteralParmDTO();
  private items: ProdutoEnteralListItemDTO[] = [];

  private headers: any = [
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'Grupo', value: 'nomeGrupo', sortable: false },
    { text: 'Fabricante', value: 'nomeFabricante', sortable: false },
    { text: 'Usuário alteração', value: 'alteradoPor', sortable: false },
    { text: 'Data', value: 'ultimaAlteracao', sortable: false },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];

  private pagination: PaginationSyncDTO = new PaginationSyncDTO();
  private pagina: ResultPagDTO<ProdutoEnteralListItemDTO> = new ResultPagDTO<ProdutoEnteralListItemDTO>();

  private mounted(): void {
    this.loadGroups();
    this.loadMakers();
    this.pesquisar();
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  private onChangeSearch() {
    if (this.loading) {
      return;
    }
    this.pesquisar();
  }

  private loadGroups() {
    this.loadingGroups = true;
    this.addSubsc(
      service.getEnteralProductGroups().subscribe(
        (result) => {
          this.grupos = result;
          this.loadingGroups = false;
        },
        (error) => {
          this.loadingGroups = false;
        },
      ),
    );
  }

  private loadMakers() {
    this.loadingMakers = true;
    this.addSubsc(
      service.getEnteralProductMakers().subscribe(
        (result) => {
          this.fabricantes = result;
          this.loadingMakers = false;
        },
        (erro) => {
          this.loadingMakers = false;
        },
      ),
    );
  }

  private pesquisar() {
    this.loading = true;
    this.error = false;
    this.filtros.page = this.pagination.page;
    this.filtros.size = this.pagination.rowsPerPage;    
    this.addSubsc(
      service.getEnteralsProducts(this.filtros).subscribe(
        (result) => {
          this.loading = false;
          this.pagina = result;
          this.items = this.pagina.content;
          PaginationSyncDTO.update(this.pagination, result);
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      ),
    );
  }

  private newItem(): void {
    this.formIsEdit = true;
    this.formOpen = true;
    this.id = null;
  }

  private onEditItem(item): void {
    this.formIsEdit = true;
    this.formOpen = true;
    this.id = item.id;
  }

  private closeForm(): void {
    this.formOpen = false;
    this.id = null;
    this.loadMakers();
  }

  private saveItem(): void {
    this.closeForm();
    this.pesquisar();
  }
}
